<div class="all-title-box"><div class="container text-center"><h1>Password Recovery</h1></div></div>
<div class="section wb auth-page">
  <div class="container auth-grid">
    <form [formGroup]="requestForm" (ngSubmit)="requestReset()" class="auth-card">
      <h3>Request reset</h3>
      <input class="form-control" type="email" formControlName="email" placeholder="Email">
      <button class="btn btn-light btn-radius btn-brd grd1 btn-block" type="submit">Send reset token</button>
    </form>

    <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" class="auth-card">
      <h3>Complete reset</h3>
      <input class="form-control" type="text" formControlName="token" placeholder="Reset token">
      <input class="form-control" type="password" formControlName="password" placeholder="New password">
      <button class="btn btn-light btn-radius btn-brd grd1 btn-block" type="submit">Reset password</button>
    </form>

    <div class="col-12">
      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert alert-success" *ngIf="message">{{ message }}</div>
    </div>
  </div>
</div>
